import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';

import { faSave, faRemove } from '@fortawesome/free-solid-svg-icons';

import BreadcrumbComponent from '@component/Breadcrumb';
import ButtonComponent from '@component/Form/Button';
import CpfComponent from '@component/Form/Cpf';
import DateComponent from '@component/Form/Date';
import InputComponent from '@component/Form/Input';
import SelectComponent from '@component/Form/Select';
import TextareaComponent from '@component/Form/Textarea';

import { DepartmentService } from '@service/departments';
import { OmbudsmanManifestationService } from '@service/ombudsman/manifestations';
import { OmbudsmanOriginService } from '@service/ombudsman/origins';
import { OmbudsmanTypeService } from '@service/ombudsman/types';

import { AclService } from '@service/acl';
import { GenericService } from '@service/generic';

import Swal from 'sweetalert2';


const breadcrumbItems = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Ouvidoria', url: '/ombudsman/manifestations' },
    { title: 'Nova Manifestação' }
];


export default function ManifestationsEdit()
{
    const navigate = useNavigate();

    const { manifestation_id } = useParams();

    const [anonymous, setAnonymous] = useState(false);

    const [typeOptions, setTypeOptions] = useState([]);
    const [originOptions, setOriginOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register,
        setValue,
        reset
    } = useForm({ mode: 'onChange' })


    const fetchManifestation = async () => {
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });

        await OmbudsmanManifestationService.show(manifestation_id)
            .then(async response => {

                setValue('date', response.data.date);

                if (response.data.type) { setValue('id_type', response.data.type.id); }

                if (response.data.origin) { setValue('id_origin', response.data.origin.id); }

                if (response.data.department) { setValue('id_departament', response.data.department.id); }

                setAnonymous(response.data.complainer ? false : true);
                if (response.data.complainer) {
                    setValue('cpf', response.data.complainer.cpf || null);
                    setValue('card', response.data.complainer.card || null);
                    setValue('name', response.data.complainer.name || null);
                    setValue('date_birth', response.data.complainer.date_birth || null);
                    setValue('email', response.data.complainer.email || null);
                    setValue('phone', response.data.complainer.phone || null);
                }

                setValue('description', response.data.description);

                Swal.close();

            });
    }


    const onSubmit = async (data, e) => {
        e.preventDefault();
        
        data.status = true;
        data.id_user = AclService.getUser().id;
        console.log(data);

        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });
        
        await OmbudsmanManifestationService.update(data, manifestation_id)
            .then(response => {

                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    html: response.data.message,
                    icon: 'success',
                }).then(() => navigate(`/ombudsman/manifestations/details/${response.data.ombudsman_manifestation_id}`));

            })
            .catch(error => { 
                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    icon: 'error',
                    text: error.response.message
                });
            });

    }

    
    useEffect(() => { 
        GenericService.selectOptions(OmbudsmanTypeService, setTypeOptions);
        GenericService.selectOptions(OmbudsmanOriginService, setOriginOptions);
        GenericService.selectOptions(DepartmentService, setDepartmentOptions);
        fetchManifestation();
    }, [manifestation_id])


    return (

        <>

            <div className='header' id='customer_form'>
                <h1 className='header-title'>Nova Ocorrência</h1>
                <BreadcrumbComponent breadcrumb={breadcrumbItems} />
            </div>


             <Form 
                autoComplete='off'
                id='form-manifestation-edit'
                noValidate
                onSubmit={handleSubmit(onSubmit)}>
            
                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={2}>
                                        {/* <DateComponent
                                            control={control}
                                            errors={errors}
                                            label='Data da Ocorrência'
                                            name='date'
                                            register={register}
                                            required={true}
                                        /> */}
                                        <InputComponent
                                            control={control}
                                            errors={errors}
                                            label='Data da Ocorrência'
                                            name='date'
                                            placeholder='DD/MM/AAAA'
                                            required={false}
                                            type='text'
                                            register={register}
                                            disabled={true}
                                        />
                                    </Col>

                                    <Col lg={2}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Tipo de Manifestação'
                                            name='id_type'
                                            register={register}
                                            required={true}
                                            options={typeOptions}
                                        
                                        />
                                    </Col>

                                    <Col lg={2}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Origem da Manifestação'
                                            name='id_origin'
                                            register={register}
                                            required={true}
                                            options={originOptions}
                                        />
                                    </Col>

                                    <Col lg={3}>
                                        <SelectComponent
                                            control={control}
                                            errors={errors}
                                            label='Departamento'
                                            name='id_departament'
                                            register={register}
                                            required={true}
                                            options={departmentOptions}
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={4}>


                                        <Form.Group>
                                            <Form.Label htmlFor='anonymous'>Qual tipo de identificação deseja utilizar para manifestante?</Form.Label>
                                            <div class="btn-group btn-group-toggle mb-3" data-toggle="buttons">
                                                <label className={`btn btn-lg btn-primary ${anonymous === false ? 'active' : null}`}>
                                                    <input type="radio" name="radio_anonymous" autocomplete="off" onClick={(e) => setAnonymous(false)} value={false} checked style={{display:'none'}} /> Identificada
                                                </label>

                                                <label className={`btn btn-lg btn-primary ${anonymous === true ? 'active' : null}`}>
                                                    <input type="radio" name="radio_anonymous" autocomplete="off" onClick={(e) => setAnonymous(true)} value={true} style={{display:'none'}} /> Anônima
                                                </label>
                                            </div>
                                            <Form.Control control={control} errors={errors} type='hidden' name='anonymous' value={anonymous} register={register} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className={anonymous === true ? 'd-none' : 'd-block'}>

                                    <Row className='mb-3'>
                                        <Col lg={2}>
                                            <CpfComponent
                                                control={control}
                                                errors={errors}
                                                label='CPF'
                                                name='cpf'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Cartão SUS'
                                                name='card'
                                                placeholder='Informe o código do cartão SUS'
                                                required={false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={6}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Nome Completo'
                                                name='name'
                                                placeholder='Informe o nome completo'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <DateComponent
                                                control={control}
                                                errors={errors}
                                                label='Data Nascimento'
                                                name='date_birth'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={3}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='E-mail'
                                                name='email'
                                                placeholder='Informe o e-mail'
                                                required={false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={3}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Telefone/Celular'
                                                name='phone'
                                                placeholder='Informe o telefone'
                                                required={anonymous === false ? true : false}
                                                disabled={anonymous === true ? true : false}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>
                                    </Row>

                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={12}>
                                        <h4>Ocorrência</h4>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col lg={12}>
                                        <TextareaComponent
                                            control={control}
                                            errors={errors}
                                            name='description'
                                            placeholder='Descriva o ocorrido'
                                            required={true}
                                            register={register}
                                            rows={4}
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


                <Row className='mb-3'>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Row>
                                    <Col lg={6}>
                                        <ButtonComponent
                                            variant='danger'
                                            icon={faRemove}
                                            id='btn-cancel'
                                            title='Cancelar'
                                            type='button'
                                            onClick={() => navigate('/ombudsman/manifestations')}
                                        />
                                    </Col>

                                    <Col lg={6} className='text-end'>
                                        <ButtonComponent
                                            variant='success'
                                            icon={faSave}
                                            id='btn-save'
                                            title='Gravar'
                                        />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            
            </Form>

        </>

    )
}
